var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accounts-list',{attrs:{"pagination":_vm.pagination,"filters":_vm.filters},on:{"update:pagination":[function($event){_vm.pagination=$event},_vm.updateRoute],"update:filters":[function($event){_vm.filters=$event},_vm.updateRoute]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e55b33d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/accounts/views/List.vue
// module id = null
// module chunks = 